module.exports = __webpack_public_path__ + "static/media/aum_logo.8396aec4.svg";